import React from "react";
import { AppRouteURI, AppRoutingRoles } from "router/RoleBasedAccess";
import App from "../app/App";
import InvitesContainer from "./InvitesContainer";

export default () => {
  const { isProtected, checkRoles } = {
    ...AppRoutingRoles[AppRouteURI.INVITES],
  };
  return (
    <App
      isProtected={isProtected}
      checkRoles={checkRoles}
      showSidebar={true}
      adminHeader={true}
    >
      <InvitesContainer />
    </App>
  );
};
